import { Routes } from '@angular/router';
import { DowntimeComponent } from './downtime/downtime.component';

export const downtimeRoutes: Routes = [
  {
    path: '',
    component: DowntimeComponent,
  },
  {
    path: 'contact-us',
    loadComponent() {
      return import('./contact-us/contact-us.component').then((m) => m.ContactUsComponent);
    },
  },
  {
    path: 'submit-request',
    loadComponent() {
      return import('./submit-request/submit-request.component').then((m) => m.SubmitRequestComponent);
    },
  },
  {
    path: 'confirm-submission',
    loadComponent() {
      return import('./confirm-submission/confirm-submission.component').then((m) => m.ConfirmSubmissionComponent);
    },
  },
];
